// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS: string[] = [
	'confluence.ssr.page-statuses',
	'confluence_react_streaming',
	'confluence_frontend_vc_observer_initialization',
	'enable_loadable_placeholder_for_legacy_macros',
	'platform-ssr-table-resize',
	'content_early_connect_iframe_initialization',
	'confluence_emit_v3_debug_data',
	'nav4_confluence_global_links',
	'confluence_use_atlaspack',
	'confluence_use_atlaspack_variant_1',
	'confluence_use_atlaspack_variant_2',
	'platform_ufo_exclude_3p_extensions_from_ttvc',
	'confluence_frontend_v2_removal',
	'confluence_frontend_statlas_redirect',
	'confluence_use_react-compiler',
	'confluence_ssr_cookie_banner_black_space',
	'confluence_space_apps_ssr_preload',
	'cc_mohiti_restricted_content_screen_ab_exp',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS: never[] = [];
